import React from 'react';
import { ByggSelectorItem } from './ByggSelectorItem';
import type { ByggSelectorVirtualListData } from './types';

export interface VirtualByggItemProps {
    index: number;
    style: React.CSSProperties;
    data: ByggSelectorVirtualListData;
}

export const VirtualByggItem = React.memo<VirtualByggItemProps>(
    ({ index, style, data }) => {
        const {
            byggFavoritterData,
            openMineBygg,
            disabled,
            onSelect,
            onDelete,
        } = data;
        const bygg = byggFavoritterData[index];

        return (
            <div style={style}>
                <ByggSelectorItem
                    key={bygg.id}
                    bygg={bygg}
                    openMineBygg={openMineBygg}
                    disabled={disabled}
                    onSelect={onSelect}
                    onDelete={onDelete}
                />
            </div>
        );
    },
);

VirtualByggItem.displayName = 'VirtualByggItem';
